import {
  collection,
  selection,
} from 'common/store/actions';

export const NAMESPACE = 'DEVICE/DEVICES';
export const PURGE = `${NAMESPACE}/PURGE`;

const collectionActions = collection.factory(NAMESPACE);
const selectionActions = selection.factory(NAMESPACE);

export const {
  LOAD,
  UPDATE,
  LOAD_SUCCESS,
  LOAD_ERROR,
  TOGGLE_SORT,
  PAGINATION_CHANGE,
  SEARCH,
  ADVANCED_SEARCH,
  DOWNLOAD,
  DOWNLOAD_INPROGRESS,
  DOWNLOAD_SUCCESS,
  DOWNLOAD_ERROR,
} = collectionActions.TYPES;

export const DEVICES_FILTER_BY_TAG = 'DEVICES/DEVICES_FILTER_BY_TAG';
export const REMOVE_DEVICES_FILTER_BY_TAG = 'DEVICES/REMOVE_DEVICES_FILTER_BY_TAG';

export const {
  SET_SELECTED,
  CLEAR_SELECTED,
} = selectionActions.TYPES;

export const {
  setSelected,
  clearSelected,
} = selectionActions;

export const {
  load,
  loadSuccess,
  loadError,
  toggleSort,
  update,
  search,
  paginationChange,
  advancedSearch,
  download,
  downloadInprogress,
  downloadSuccess,
  downloadError,
} = collectionActions;

export const purge = deviceId => ({
  type: PURGE,
  deviceId,
});

export const devicesFilterByTag = (tag)=> {
  return {
    type: DEVICES_FILTER_BY_TAG,
    tag
  }
}

export const removeDevicesFilterByTag = ()=> {
  return {
    type: REMOVE_DEVICES_FILTER_BY_TAG,
  }
}
